/* eslint-disable */
import React, { Component } from 'react';

var _ = require('lodash');
var tr = require('ts-translate-js').default.boundTR;
var tsRest = require('ts-rest-client');
var MarkDown = require("react-markdown");

export type TicketsListProps = {
    tickets: any[],
    eventDateID: number,
    showPlan?: boolean,
    onShowPlanClick?: () => void,
    onContentChange?: () => void,
}

export type TicketsListState = {
    sectionInfos: any
}

export class TicketsList extends Component<TicketsListProps, TicketsListState> {
    sectionInfosProm: any;
    static displayName: string;
    static defaultProps: { isInMultiEventMode: boolean; };

    constructor(props) {
        super(props);

        this.state = {
            sectionInfos: null 
        };

        /** @type {tsRest.TSServiceCall} */
        this.sectionInfosProm = null;

        this.handleOnShowPlanClick = this.handleOnShowPlanClick.bind(this);
    }

    componentDidMount() {
        this.loadSectionInfos();
        
        if(this.props.onContentChange != null) this.props.onContentChange();
    }

    componentDidUpdate() {
        if(this.props.onContentChange != null) this.props.onContentChange();
    }

    componentWillUnmount() {
        if(this.sectionInfosProm != null) this.sectionInfosProm.abort();
    }
    
    loadSectionInfos() {
        // Load the urls for this integration
        this.sectionInfosProm = tsRest.get("/eventdates/" + this.props.eventDateID + "/tickets/" + _.first(this.props.tickets).TicketID + "/sectioninfos", { noCache: true });
        this.sectionInfosProm.done((info) => {
            this.setState({ sectionInfos: info });
        });
    }

    handleOnShowPlanClick(e) {
        e.preventDefault();
        if (this.props.onShowPlanClick != null) this.props.onShowPlanClick();
    }

    render() {
        var tickets = [];

        tickets = _.orderBy(this.props.tickets, 'Name');

        var ticketsList = _.map(tickets, (ticket) => <div key={ticket.TicketID} className="col-xs-6 col-sm-3 col-md-2"><label className="label label-info col-xs-12">{ticket.Name}</label></div>);

        // tag span nowrap car l'icon changeait de ligne en xs
        // normalwrap sur le text du lien pour que lui wrap
        var btnShowPlan = null;
        if(this.props.showPlan)
            btnShowPlan = (<div className="col-xs-12 col-sm-6 col-md-4">
                <a href="#" className="text-bold" onClick={this.handleOnShowPlanClick}>
                         <h5 className="nowrap">
                             <i className="fa fa-map-marker"></i>&nbsp;<span className="normalwrap">{tr("Visionner sur le plan")}</span>
                         </h5>
                     </a>
                 </div>);

        var specialSectionMessage = null;
        if(this.state.sectionInfos != null && this.state.sectionInfos.SpecialMessage != "") {
            specialSectionMessage = <div className="col-xs-12 col-sm-5"><div className="alert alert-warning" role="alert"><MarkDown source={this.state.sectionInfos.SpecialMessage}></MarkDown></div></div>;
        }
        
        return (
            
            <div>
                <div className="row">
                    <div className="col-xs-12">
                        <h5><strong>{tsapp.trN('Siege propose', 'Sieges proposes', { n: this.props.tickets.length })}</strong></h5>
                    </div>
                    <div className="col-xs-12">
                        <div className="tickets-info">
                            {ticketsList}
                            {btnShowPlan}
                        </div>
                    </div>
                </div>
                <div className="row">
                    {specialSectionMessage}
                </div>
            </div>
        );
    }
};
